/* eslint-disable no-unused-vars */
import React, { useContext } from 'react'
import { strCol, numCol, dateTimeCol } from '@integec/grid-tools/lib/cols'
// import { OaEventIoHeaders } from './../Headers'
import { rowHeaderRender } from 'core/utils'
import MarginAnalysisContext from 'marginanalysis/MarginAnalysisContext'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import { Modal, Table } from 'antd'
import { getFinalData } from 'marginanalysis/utils'

const header = [
  numCol({ ident: 'referenceNo', display: 'Reference No', isFiltered: true }),
  strCol({
    ident: 'explanation',
    display: 'Explanation',
    isFiltered: true,
    width: 700,
  }),
]

const antdHeader = [
  {
    key: 'referenceNo',
    dataIndex: 'referenceNo',
    title: 'Reference No',
    width: 100,
  },
  {
    key: 'explanation',
    dataIndex: 'explanation',
    title: 'Explanation',
  },
]

const ConstraintList = props => {
  const { whatIf, isEventPlanner = false } = props
  const marginContext = useContext(MarginAnalysisContext)
  const { constantsData = [] } = getFinalData(
    marginContext,
    whatIf,
    isEventPlanner
  )

  return (
    <Modal
      title="Expansion Data"
      visible={props.visible}
      onOk={_ => props.setClose(false)}
      onCancel={_ => props.setClose(false)}
      footer={<div />}
      width="900px"
      bodyStyle={{
        display: 'grid',
        minHeight: '350px',
        // maxHeight: '500px',
        top: '20px',
      }}
      destroyOnClose
      style={{ top: 20 }}
    >
      <Table
        dataSource={constantsData}
        columns={antdHeader}
        size="small"
        style={{ maxHeight: '' }}
        scroll={{ y: 400 }}
        pagination={false}
      />
      {/* <Grid
        data={constantsData}
        headers={header}
        altBgColor="#ebebeb"
        render={virtualizedGridRenderer({
          // autoFixColByKey,
          rowHeaderRender,
          height: 300,
          width: 800,
          headerRowHeight: 30,
        })}
        selectionType="row"
        selectionMode="single"
      /> */}
    </Modal>
  )
}

export default ConstraintList
